// Centralized API Configuration
// This file contains all backend API URLs and endpoints
// Update this file when you need to change the backend URL

export const API_CONFIG = {
  // Base URL for the backend API
  // Manually switch between local and production URLs
  // BASE_URL: 'https://backend-service-996554652457.asia-south1.run.app', // Production
    // BASE_URL: 'https://localhost:7180', // Local Development,
  BASE_URL: 'https://firecrackeronlinewebsite.onrender.com', // Production
  
  // API Endpoints
  ENDPOINTS: {
    // Product endpoints
    PRODUCT: {
      BASE: '/Product',
      GET_BY_CATEGORY: '/GetAllProductByCategoryId',  
      GET_ALL_COMPANIES: '/GetAllCompanies',
      GET_BY_COMPANY: '/GetAllProductsByCompany',
      RENAME_COMPANY: '/RenameCompany',
      DELETE_COMPANY: '/DeleteCompany',
      UPDATE: '/UpdateProductDetails',
      DELETE: '/DeleteProduct',
      ADD: '/AddProduct',
    },
    
    // User endpoints
    USER: {
      BASE: '/User',
      LOGIN: '/Login',
      SIGNUP: '/SignIn',
      GET_DETAILS: '/GetUserDetails',
    },
    
    // Order endpoints
    ORDER: {
      BASE: '/Order',
      CREATE: '/CreateOrder',
      GET_DETAILS: '/GetOrderDetails',
      GET_ALL: '/GetAllOrder',
      GET_MY_ACTIVE: '/GetMyActiveOrders',
      MARK_COMPLETE: '/MarkOrderComplete',
    },
    
    // Category endpoints
    CATEGORY: {
      BASE: '/Category',
      GET_ALL: '/GetAllCategory',
      CREATE: '/CreateCategory',
      UPDATE: '/UpdateCategory',
      DELETE: '/DeleteCategory',
    },
  },
} as const;

// Helper function to build full URLs
export const buildApiUrl = (endpoint: string, params?: Record<string, string | number>): string => {
  let url = `${API_CONFIG.BASE_URL}${endpoint}`;
  
  if (params) {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      searchParams.append(key, value.toString());
    });
    url += `?${searchParams.toString()}`;
  }
  
  return url;
};

// Export individual URL builders for convenience
export const getProductUrl = (endpoint: string) => 
  `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.PRODUCT.BASE}${endpoint}`;

export const getUserUrl = (endpoint: string) => 
  `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.USER.BASE}${endpoint}`;

export const getOrderUrl = (endpoint: string) => 
  `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.ORDER.BASE}${endpoint}`;

export const getCategoryUrl = (endpoint: string) => 
  `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.CATEGORY.BASE}${endpoint}`;
